import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  title: {
    fontSize: 16.5,
  },
  subTitle: {
    fontSize: 11,
    color: '#586375',
  },
  inline: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  wallet: {
    height: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  transferButton: {
    background: '#009358',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      float: 'none',
    },
    '&:hover': {
      background: '#007A49',
    },
    '&:disabled': {
      background: '#eee',
    },
  },
}));
